import React, { useRef, useState, useEffect } from 'react';
import { ReactComponent as IconPin } from 'images/pin.svg';
import { ReactComponent as IconEye } from 'images/eye2.svg';
import { ReactComponent as IconEyeClosed } from 'images/pass-hidden.svg';
import { formatNumber } from 'sdk/utils/formatValues';
import clsx from 'clsx';
import styles from './UserVideoView.module.scss';

let interval: NodeJS.Timeout | undefined

function UserVideoView(props: any) {
  const post = props?.data
  const className = props?.className
  const videoRef = useRef<HTMLVideoElement>(null)
  const video = videoRef?.current
  const [videoProgress, setVideoProgress] = useState(0)

  const getProgress = () => (
    (video && video?.duration) ? (
      ((video?.currentTime || 0) / (video?.duration || 1)) * 100
    ) : 0
  )

  const startVideo = () => {
    if (video) {
      video.play()
      if (interval) clearInterval(interval)
      setVideoProgress(getProgress())
      interval = setInterval(() => setVideoProgress(getProgress()), 1000)
    }
  }

  const stopVideo = () => {
    if (video) {
      video.pause()
      setVideoProgress(getProgress())
      if (interval) clearInterval(interval)
    }
  }

  useEffect(() => {
    const videoEl = videoRef.current;
    return () => {
      if (videoEl) {
        videoEl.pause()
      }
    }
  }, [])

  useEffect(() => () => {
    if (interval) clearInterval(interval)
  }, [])

  useEffect(() => {
    if (!props?.isActive) {
      stopVideo()
    } else {
      startVideo()
    }
  }, [props?.isActive])

  const views = 12821

  return (
    <a
      href={`/post/${post?.id}`}
      className={clsx(
        className,
        styles.container,
        props?.size && styles[`containerSize-${props?.size}`],
        props?.min && styles.containerMin,
      )}
      style={props?.style}
      onClick={() => {
        const isVideoPlaying = Boolean(
          Number(video?.currentTime) > 0
          && !video?.paused
          && !video?.ended
          && Number(video?.readyState) > 2,
        );
        if (isVideoPlaying) {
          stopVideo()
        } else {
          const videos = document.getElementsByTagName('video')
          for (let i = 0; i < videos.length; i += 1) {
            videos[i].pause()
          }
          startVideo()
        }
      }}
    >
      <video
        src={post?.video_link}
        poster={post?.bg_cover || ''}
        autoPlay={false}
        ref={videoRef}
        preload="auto"
      />

      <div className={styles.containerInfoTop}>
        {props?.min ? null : (
          <>
            <div className={styles.views}>
              {views ? (
                <>
                  <IconEye />
                  {formatNumber(views).toLowerCase()}
                </>
              ) : (<IconEyeClosed />)}
            </div>
            <div className={styles.pinIcon}>
              <IconPin />
            </div>
          </>
        )}
      </div>

      <div className={styles.containerInfoBottom}>
        <div className={styles.title}>
          {post?.description}
        </div>

        <div className={styles.videoProgressContainer}>
          <div
            className={styles.videoProgress}
            style={{ width: `${videoProgress || 0}%` }}
          />
        </div>
      </div>
    </a>
  )
}

export default UserVideoView
